import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/12.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Wchodzę do szewca"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p28,
            }}
            content={
                <div>
                    <p>
                        Z warsztatu słychać głośne stukanie. Pukasz, ale nikt ci nie odpowiada. Pukasz głośniej i stukanie cichnie.
                    </p>
                    <ul>
                        <li>Kto tam? Wejść! – słyszysz.</li>
                    </ul>
                    <p>
                        Otwierasz drzwi. W maleńkiej izdebce na taborecie siedzi wąsaty mężczyzna i ćwiekuje buty. Wokół stołu rozrzucone są dratwy, nóż, drewniane kopyto, cęgi i inne narzędzia.
                    </p>
                    <ul>
                        <li>Dzień dobry! Nie potrzebuje pan pracownika?</li>
                        <li>Pracownika? A z czego ja ci zapłacę? Spytaj u zduna naprzeciwko, może on potrzebuje. Ja sam dopiero szukam klientów.</li>
                        <li>Zduna?</li>
                        <li>Jeden jest w Zagórowie. Naprzeciwko mojej chałupy, raczej się nie zgubisz! – zaśmiewa się szewc.</li>
                    </ul>
                    <p>
                        Jednak przeczucie cię nie myliło. Wychodzisz i kierujesz się do warsztatu zduna, przed którym leżą ceramiczne kafle.
                    </p>
                </div>
            }
        />

    );
}